import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLayoutBottom: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"layout-bottom, margin, padding"} maskId="square-filled-radius-0-stroke-1-IconLayoutBottom"><path d="M3 18V3H21V18H3Z" fill="currentColor"/><path d="M3 21V20H21V21H3Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconLayoutBottom;
